<template>
  <div class="courseList">
    <div class="line relative">
      <el-input
        class="search-input"
        v-model="courseId"
        placeholder="输入课程ID"
        clearable
      ></el-input>
      <el-input
        class="search-input"
        v-model="course_name"
        placeholder="输入课程标题"
        clearable
      ></el-input>
      <el-select
        class="search-select"
        v-model="grade"
        placeholder="课程年级"
        clearable
      >
        <el-option
          v-for="item in grades"
          :label="item.name"
          :value="item.id"
          :key="item.id"
        ></el-option>
      </el-select>
      <el-select
        class="search-select"
        v-model="is_vip"
        placeholder="会员状态"
        clearable
      >
        <el-option label="会员" value="1"></el-option>
        <el-option label="非会员" value="0"></el-option>
      </el-select>
      <el-select
        class="search-select"
        v-model="on_shelf"
        placeholder="上架状态"
        clearable
      >
        <el-option label="上架" value="1"></el-option>
        <el-option label="下架" value="0"></el-option>
      </el-select>
      <el-button class="search-button" type="primary" @click="search(true)"
        >查询</el-button
      >
      <el-button
        class="search-button"
        style="position: absolute; right: 20px"
        type="primary"
        @click="toAdd()"
        >新建课程</el-button
      >
    </div>
    <el-table class="data-table" :data="courseData" v-loading="loading">
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="50"
      ></el-table-column>
      <el-table-column label="课程信息" width="width">
        <template slot-scope="scope">
          <div class="flex">
            <el-image
              class="avatar"
              :src="scope.row.cover"
              :preview-src-list="[scope.row.cover]"
              fit="contain"
            ></el-image>
            <div style="width: 100%">
              <div class="userInfo">《{{ scope.row.course_name }}》</div>
              <div class="userInfo">
                课件数量：{{ scope.row.courseware_count }}
              </div>
              <div class="userInfo">{{ gradeName[scope.row.grade] }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="会员专享" width="80">
        <template slot-scope="scope">
          <div>{{ scope.row.is_vip == 1 ? '是' : '否' }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="点赞/收藏/完课人数">
        <template slot-scope="scope">
          <div>
            {{ scope.row.star_count }}/{{ scope.row.collect_count }}/{{
              scope.row.complete_count
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="上/下架" width="width">
        <template slot-scope="scope">
          <div>
            <div>
              <el-switch
                :value="scope.row.on_shelf == 1"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="onShelfChange($event, scope.row)"
              ></el-switch>
            </div>
            <div>
              分类：{{ scope.row.on_shelf ? scope.row.category : '未上架' }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <div>
            <div v-if="webType == 1" style="margin-bottom: 5px">
              <el-button
                type="primary"
                size="mini"
                @click="toStudent(scope.row.id)"
                >学生列表</el-button
              >
              <el-button type="primary" size="mini" @click="toKs(scope.row.id)"
                >课时管理</el-button
              >
            </div>
            <div>
              <el-button
                v-if="webType == 2"
                type="primary"
                size="mini"
                @click="toKs(scope.row.id)"
                >课时管理</el-button
              >
              <el-button type="primary" size="mini" @click="toEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="toDelCourse(scope.row.id)"
                >删除</el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="onCoursePageChange"
      :current-page="page"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <!-- 新建、编辑 -->
    <el-dialog
      :title="isAdd ? '新建课程' : '编辑课程'"
      :visible.sync="addVisible"
      width="60%"
    >
      <el-row :gutter="10" class="detail-row">
        <el-col :span="3">课程标题：</el-col>
        <el-col :span="18" class="text-left">
          <el-input
            v-model="addInfo.course_name"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="3">课程年级：</el-col>
        <el-col :span="6" class="text-left">
          <el-select
            class="search-select"
            v-model="addInfo.grade"
            placeholder="课程年级"
            clearable
          >
            <el-option
              v-for="item in grades"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">会员专享：</el-col>
        <el-col :span="6">
          <el-radio-group v-model="addInfo.is_vip">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="3">课程封面：</el-col>
        <el-col :span="18" class="text-left">
          <div v-if="addInfo.cover" class="relative">
            <el-image
              style="width: 70px; height: 40px"
              :src="addInfo.cover"
              :preview-src-list="[addInfo.cover]"
              fit="contain"
            ></el-image>
            <el-button
              class="img-del-button"
              type="primary"
              @click="
                tempPic = null
                addInfo.cover = null
              "
              >删除</el-button
            >
          </div>
          <div v-else class="relative">
            <el-button type="primary">上传图片</el-button>
            <input
              class="hidden-input"
              type="file"
              accept="image/*"
              @change="chooseCover"
            />
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="3">课程介绍：</el-col>
        <el-col :span="18" class="text-left">
          <el-button type="primary" style="margin-right: 10px" @click="addIntro"
            >插入文字</el-button
          >
          <span class="button-container" style="margin-right: 10px">
            <el-button type="primary" @click="addIntro(1)">插入图片</el-button>
            <input
              class="hidden-input"
              type="file"
              accept="image/*"
              @change="chooseIntroPic"
            />
          </span>
          <span class="button-container">
            <el-button type="primary" @click="addIntro(2)">插入视频</el-button>
            <input
              class="hidden-input"
              type="file"
              accept="video/*"
              @change="chooseIntroVideo"
            />
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="3" style="opacity: 0">课程介绍：</el-col>
        <el-col :span="18" class="text-left">
          <div
            class="relative"
            style="margin-bottom: 10px"
            v-for="(item, index) in addInfo.content"
            :key="index"
          >
            <div class="intro-text" v-if="item.type == 'text'">
              <el-input
                v-model="item.text"
                type="textarea"
                placeholder=""
              ></el-input>
            </div>
            <el-image
              class="intro-pic"
              v-if="item.type == 'image'"
              :src="item.url"
              :preview-src-list="[item.url]"
              fit="contain"
            ></el-image>
            <video
              class="intro-video"
              controls
              v-if="item.type == 'video'"
              :src="item.url"
            ></video>
            <el-button class="intro-del" type="primary" @click="delIntro(index)"
              >删除</el-button
            >
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="onAddCourseConfirm">保存</el-button>
      </span>
    </el-dialog>
    <!-- 学生列表 -->
    <el-dialog title="学生列表" :visible.sync="studentListVisible" width="60%">
      <div class="line" style="padding-top: 0">
        <el-input
          class="search-input"
          v-model="studentId"
          placeholder="输入用户ID"
          clearable
        ></el-input>
        <el-input
          class="search-input"
          v-model="studentName"
          placeholder="输入用户昵称"
          clearable
        ></el-input>
        <el-select
          class="search-select"
          v-model="studentFinished"
          placeholder="是否完课"
          clearable
        >
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
        <el-button class="search-button" type="primary" @click="searchStudent()"
          >查询</el-button
        >
      </div>
      <el-table class="data-table" :data="studentData" v-loading="loading">
        <el-table-column
          align="center"
          prop="id"
          label="ID"
          width="50"
        ></el-table-column>
        <el-table-column align="center" label="用户信息" width="width">
          <template slot-scope="scope">
            <div class="flex">
              <img class="avatar" :src="scope.row.avatar" alt="" />
              <div style="width: 100%">
                <div class="userInfo">{{ scope.row.nick_name }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否完课" width="width">
          <template slot-scope="scope">
            <div>{{ scope.row.complete == 1 ? '是' : '否' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="duration"
          label="本课学习时长"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="width">
          <template slot-scope="scope">
            <div>
              <el-button
                type="primary"
                size="mini"
                @click="toStudentDetail(scope.row.id)"
                >学生详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onStudentPageChange"
        :current-page="pageStudent"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="totalStudent"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="studentListVisible = false">返回</el-button>
      </span>
    </el-dialog>
    <!-- 课程上架 -->
    <el-dialog title="课程上架" :visible.sync="shelfVisible" width="30%">
      <el-row :gutter="10" class="detail-row">
        <el-col :span="10">上架课程分类：</el-col>
        <el-col :span="14" class="text-left">
          <el-select
            class="search-select"
            v-model="shelfType"
            placeholder="选择分类"
            clearable
          >
            <el-option
              v-for="(item, index) in categorys"
              :label="item"
              :value="item"
              :key="index"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shelfVisible = false">返回</el-button>
        <el-button type="primary" @click="onCourseShelf">保存</el-button>
      </span>
    </el-dialog>
    <!-- 课时管理 -->
    <el-dialog
      title="课时管理"
      :visible.sync="ksVisible"
      width="80%"
      @close="toCloseKs"
    >
      <div class="line" style="padding-top: 0; justify-content: flex-end">
        <el-button type="primary" @click="toAddKs">新建课时</el-button>
      </div>
      <el-table class="data-table" :data="ksData" v-loading="loading">
        <el-table-column align="center" label="序号" width="50">
          <template slot-scope="scope">
            <div>
              {{ scope.$index + 1 + (pageKs - 1) * 10 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="课时标题"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="courseware_count"
          label="课件数量"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="width">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" @click="toKj(scope.row.id)"
                >课件管理</el-button
              >
              <el-button type="primary" size="mini" @click="toEditKs(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="toDelKs(scope.row.id)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onKsPageChange"
        :current-page="pageKs"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="totalKs"
      >
      </el-pagination>
    </el-dialog>
    <!-- 新建/编辑课时 -->
    <el-dialog
      :title="isKsAdd ? '新增课时' : '编辑课时'"
      :visible.sync="ksAddVisible"
      width="40%"
    >
      <el-row :gutter="10" class="detail-row">
        <el-col :span="6" style="text-align: center">课时标题：</el-col>
        <el-col :span="16" class="text-left">
          <el-input
            v-model="ksName"
            placeholder="请输入内容"
            clearable
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ksAddVisible = false">取消</el-button>
        <el-button type="primary" @click="onKsConfirm">保存</el-button>
      </span>
    </el-dialog>
    <!-- 课件管理(显示新建时隐藏课时管理，关闭时恢复) -->
    <!-- <el-dialog title="课件管理" :visible.sync="kjVisible" width="80%" @close="ksVisible = true"> -->
    <el-dialog
      title="课件管理"
      :visible.sync="kjVisible"
      width="80%"
      @close="toCloseKj"
    >
      <div class="line" style="padding-top: 0; justify-content: flex-end">
        <!-- <el-button type="primary">批量上传</el-button> -->
        <el-button type="primary" @click="toAddKj">新建课件</el-button>
      </div>
      <el-table class="data-table" :data="kjData" v-loading="loading">
        <el-table-column align="center" label="序号" width="50">
          <template slot-scope="scope">
            <div>
              {{ scope.$index + 1 + (pageKj - 1) * 10 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="课件标题"
        ></el-table-column>
        <el-table-column align="center" label="课件内容">
          <template slot-scope="scope">
            <div class="kj-content">
              <span v-if="scope.row.content.length == 0">暂无内容</span>
              <span
                style="margin-right: 5px"
                v-for="(item, index) in scope.row.content"
                :key="index"
                >{{
                  item.type == 1 ? item.content.name : typeDic[item.type]
                }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="width">
          <template slot-scope="scope">
            <div>
              <el-button type="primary" size="mini" @click="toEditKj(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="toDelKj(scope.row.id)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="onKjPageChange"
        :current-page="pageKj"
        :page-size="1000000"
        layout="total, prev, pager, next, jumper"
        :total="totalKj"
      >
      </el-pagination>
    </el-dialog>

    <!-- 新建编辑课件 -->
    <el-dialog
      :title="isKjAdd ? '新建课件' : '编辑课件'"
      :visible.sync="addKjVisible"
      width="80%"
    >
      <div class="line" style="padding-top: 0; justify-content: flex-end">
        <span class="button-container" style="margin-right: 10px">
          <el-button type="primary">上传视频</el-button>
          <input
            class="hidden-input"
            type="file"
            accept="video/*"
            @change="chooseKjVideo"
          />
        </span>
        <el-button type="primary" @click="toAddQuestion(2)"
          >添加问答题</el-button
        >
        <el-button type="primary" @click="toAddQuestion(3)"
          >添加选择题</el-button
        >
      </div>
      <el-row :gutter="10" class="detail-row">
        <el-col style="margin-left: 30px" :span="3">课件标题：</el-col>
        <el-col :span="12" class="text-left">
          <el-input
            v-model="kjName"
            placeholder="请输入内容"
            clearable
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-col>
      </el-row>
      <el-table class="data-table" :data="kjContentData" v-loading="loading">
        <el-table-column align="center" label="序号" width="50">
          <template slot-scope="scope">
            <div>
              {{ scope.$index + 1 + (pageKs - 1) * 10 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="类型">
          <template slot-scope="scope">
            {{ typeDic[scope.row.type] }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="内容">
          <template slot-scope="scope">
            <div class="kj-content">
              <span
                v-if="scope.row.type == 1"
                class="link"
                @click="toPreview(scope.row.content.url)"
                >{{ scope.row.content.name }}</span
              >
              <span v-else>{{ scope.row.content.question }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="width">
          <template slot-scope="scope">
            <div>
              <span
                v-if="scope.row.type == 1"
                class="button-container"
                style="margin-right: 10px; width: 80px; height: 28px"
              >
                <el-button type="primary" size="mini">重新上传</el-button>
                <input
                  class="hidden-input"
                  type="file"
                  accept="video/*"
                  @change="reChooseKjVideo($event, scope.$index)"
                />
              </span>
              <el-button
                v-else
                type="primary"
                size="mini"
                @click="toEditQuestion(scope.row, scope.$index)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="delKjContent(scope.$index)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addKjVisible = false">取消</el-button>
        <el-button type="primary" @click="onKjConfirm">{{
          isKjAdd ? '确定' : '保存'
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 预览视频 previewVideo -->
    <el-dialog
      title="视频预览"
      :visible.sync="previewVideo"
      width="80%"
      @close="closePreview"
    >
      <video
        class="preview-video"
        :src="previewVideoUrl"
        controls
        autoplay
      ></video>
    </el-dialog>
    <!-- 添加编辑题目 -->
    <el-dialog
      :title="isQuestionAdd ? '添加题目' : '编辑题目'"
      :visible.sync="questionVisible"
      width="60%"
    >
      <el-row :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">课时标题：</el-col>
        <el-col :span="16" class="text-left">
          {{ typeDic[questionInfo.type] }}
        </el-col>
      </el-row>
      <el-row :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">题干：</el-col>
        <el-col :span="16" class="text-left">
          <el-input
            type="textarea"
            rows="3"
            v-model="questionInfo.content.question"
          ></el-input>
        </el-col>
      </el-row>
      <el-row v-if="questionInfo.type == 2" :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">答案：</el-col>
        <el-col :span="16" class="text-left">
          <el-input
            type="textarea"
            rows="3"
            v-model="questionInfo.content.answer"
          ></el-input>
        </el-col>
      </el-row>
      <el-row v-if="questionInfo.type == 3" :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">答案：</el-col>
        <el-col :span="16" class="text-left">
          <el-input v-model="questionInfo.content.answer"></el-input>
        </el-col>
      </el-row>
      <el-row v-if="questionInfo.type == 3" :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">选项：</el-col>
        <el-col :span="16" class="text-left">
          <el-input v-model="questionInfo.content.option1"></el-input>
        </el-col>
      </el-row>
      <el-row v-if="questionInfo.type == 3" :gutter="10" class="detail-row">
        <el-col :span="4" style="text-align: center">选项：</el-col>
        <el-col :span="16" class="text-left">
          <el-input v-model="questionInfo.content.option2"></el-input>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="questionVisible = false">取消</el-button>
        <el-button type="primary" @click="onQuestionConfirm">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { webType } from '../../const'
import {
  getCourseList,
  saveCourse,
  upload,
  getPeriodList,
  savePeriod,
  delCourse,
  getKjList,
  delKs,
  delKj,
  saveKj,
  courseShelf,
  getStudentInCourse,
} from '@/api/api.js'
import { getGradesList } from '@/utils/common'
import { ossPut, ossOrigin, ossType } from '@/utils/oss'
export default {
  name: 'CourseList',
  data: () => ({
    webType,
    courseId: '',
    course_name: '',
    grade: '',
    is_vip: '',
    state: '',
    on_shelf: '',
    grades: [],
    gradeName: {},
    loading: false,
    courseData: [],
    page: 1,
    total: 3,
    isAdd: true,
    addVisible: false,
    addInfo: {
      course_name: '',
      grade: '',
      course_name: '',
      cover: '',
      is_vip: '',
      content: [{ type: 'text', text: '' }],
    },
    tempPic: '',
    // 学生列表
    studentId: '',
    studentName: '',
    studentFinished: '',
    studentListVisible: false,
    studentData: [
      { id: 1, nickname: 'nickname', finished: false, learnTime: '14时6分' },
      { id: 1, nickname: 'nickname', finished: false, learnTime: '14时6分' },
      { id: 1, nickname: 'nickname', finished: false, learnTime: '14时6分' },
    ],
    pageStudent: 1,
    totalStudent: 3,
    shelfVisible: false,
    categorys: [],
    shelfType: '',
    editCourseId: null,
    // 课时管理
    ksVisible: false,
    pageKs: 1,
    totalKs: 3,
    ksData: [],
    isKsAdd: true,
    ksAddVisible: false,
    ksName: '',
    editKsId: null,
    // 课件管理
    kjVisible: false,
    typeDic: ['', '视频', '问答题', '选择题'],
    kjData: [],
    pageKj: 1,
    totalKj: 0,
    addKjVisible: false,
    isKjAdd: true,
    kjName: '',
    kjContentData: [],
    editKjId: 0,
    // 题目添加、编辑
    questionVisible: false,
    isQuestionAdd: true,
    questionInfo: {
      type: 2,
      content: {
        question: '',
        answer: '',
        option1: '',
        option2: '',
      },
    },
    editQuestionIndex: -1,
    ksChanged: false,
    kjChanged: false,

    previewVideo: false,
    previewVideoUrl: '',
  }),
  async mounted() {
    this.search()
    // 获取年级列表
    this.grades = await getGradesList()
    this.grades.forEach((item) => {
      this.gradeName[item.id] = item.name
    })
  },
  methods: {
    // 课程列表搜索
    search(reset = false) {
      if (reset) {
        this.page = 1
      }
      let params = {
        page: this.page,
      }
      if (this.courseId) {
        params.id = this.courseId
      }
      if (this.course_name) {
        params.course_name = this.course_name
      }
      if (this.grade) {
        params.grade = this.grade
      }
      if (this.is_vip) {
        params.is_vip = this.is_vip
      }
      if (this.on_shelf) {
        params.on_shelf = this.on_shelf
      }
      this.loading = true
      getCourseList(params).then((res) => {
        this.loading = false
        console.log(res)
        this.courseData = res.data.data.list
        this.total = res.data.data.total
      })
    },
    // 课时列表搜索
    searchKs(reset = false) {
      if (reset) {
        this.pageKs = 1
      }
      getPeriodList(this.editCourseId, this.pageKs).then((res) => {
        this.ksData = res.data.data.list
        this.totalKs = res.data.data.total
      })
    },
    searchKj(reset = false) {
      if (reset) {
        this.pageKj = 1
      }
      getKjList(this.editKsId, this.pageKj).then((res) => {
        console.log('课件', res)
        this.kjData = res.data.data
        this.totalKj = res.data.data.length
      })
    },
    onCoursePageChange(e) {
      this.page = e
      this.search()
    },
    onKsPageChange(e) {
      this.pageKs = e
      this.searchKs()
    },
    onKjPageChange(e) {
      this.pageKj = e
      this.searchKj()
    },
    onStudentPageChange(e) {},
    toAdd() {
      this.isAdd = true
      this.addVisible = true
      this.tempPic = null
      this.addInfo = {
        course_name: '',
        grade: '',
        course_name: '',
        cover: '',
        is_vip: '',
        content: [{ type: 'text', text: '' }],
      }
    },
    chooseCover(e) {
      let file = e.target.files[0]
      var _URL = window.URL || window.webkitURL
      this.addInfo.cover = _URL.createObjectURL(file)
      this.tempPic = file
    },
    toEdit(row) {
      this.isAdd = false
      this.addVisible = true
      this.addInfo.course_name = row.course_name
      this.addInfo.grade = row.grade
      this.addInfo.cover = row.cover
      this.addInfo.is_vip = row.is_vip
      this.addInfo.content = row.content
      this.addInfo.id = row.id
      this.tempPic = null
    },
    toStudentDetail(id) {
      this.$router.push(`/userManage?id=${id}`)
    },
    toKs(id) {
      this.editCourseId = id
      this.ksVisible = true
      this.searchKs(true)
    },
    toStudent(id) {
      this.studentListVisible = true
      this.editCourseId = id
      this.searchStudent(true)
    },
    searchStudent(reset = false) {
      if (reset) {
        this.pageStudent = 1
      }
      let params = {
        page: this.pageStudent,
        course_id: this.editCourseId,
      }
      if (this.studentId) {
        params.user_id = this.studentId
      }
      if (this.studentName) {
        params.nick_name = this.studentName
      }
      if (this.studentFinished != '') {
        params.complete = this.studentFinished
      }
      getStudentInCourse(params).then((res) => {
        this.studentData = res.data.data.list
        this.totalStudent = res.data.data.total
      })
    },
    onShelfChange(e, item) {
      this.editCourseId = item.id
      if (e) {
        this.shelfVisible = true
        let gradeIndex = 0
        this.grades.forEach((grade, index) => {
          if (grade.id == item.grade) {
            gradeIndex = index
          }
        })
        this.categorys = this.grades[gradeIndex].category
      } else {
        item.on_shelf = 0
        saveCourse({ id: item.id, on_shelf: 0 }).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: '下架成功！',
              type: 'success',
            })
            this.search()
          }
        })
      }
    },
    onCourseShelf() {
      if (!this.shelfType) {
        this.$message({
          message: '请选择上架分类！',
          type: 'warning',
        })
        return
      }
      courseShelf(this.editCourseId, this.shelfType).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: `上架成功！`,
            type: 'success',
          })
          this.shelfVisible = false
          this.search()
        }
      })
    },
    toAddKs() {
      this.isKsAdd = true
      this.ksAddVisible = true
      this.ksName = ''
    },
    toEditKs(row) {
      this.isKsAdd = false
      this.ksAddVisible = true
      this.ksName = row.name
      this.editKsId = row.id
    },
    // 课件管理
    toKj(id) {
      this.ksVisible = false
      this.kjVisible = true
      this.editKsId = id
      this.searchKj(true)
    },
    //删除课程
    toDelCourse(id) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delCourse(id).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: `删除成功！`,
              type: 'success',
            })
            this.search()
          }
        })
      })
    },
    // 关闭课时
    toCloseKs() {
      if (this.ksChanged || this.kjChanged) {
        // 课时或者课件有更新
        this.ksChanged = false
        this.kjChanged = false
        this.search()
      }
    },
    //删除课时
    toDelKs(id) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delKs(id).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: `删除成功！`,
              type: 'success',
            })
            this.searchKs()
            // 删除课时，课件、课时数量有变化
            this.ksChanged = true
            this.kjChanged = true
          }
        })
      })
    },
    // 关闭课件
    toCloseKj() {
      this.searchKs()
      if (this.kjChanged) {
        // 课件有变化，刷新课时
        this.kjChanged = false
        this.searchKs()
      }
      this.ksVisible = true
    },
    //删除课件
    toDelKj(id) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delKj(id).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: `删除成功！`,
              type: 'success',
            })
            this.searchKj()
            // 删除课件时，课件和课时都有变化
            this.ksChanged = true
            this.kjChanged = true
          }
        })
      })
    },
    //删除课件内容
    delKjContent(index) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.kjContentData.splice(index, 1)
      })
    },
    toAddKj() {
      this.isKjAdd = true
      this.addKjVisible = true
      this.kjContentData = []
      this.kjName = ''
    },
    toEditKj(row) {
      this.isKjAdd = false
      this.addKjVisible = true
      this.editKjId = row.id
      this.kjName = row.title
      this.kjContentData = [...row.content]
    },
    toAddQuestion(type) {
      this.questionInfo = {
        type: type,
        content: {
          question: '',
          answer: '',
          option1: '',
          option2: '',
        },
      }
      this.questionVisible = true
      this.isQuestionAdd = true
    },
    toEditQuestion(item, index) {
      this.questionInfo = item
      this.editQuestionIndex = index
      this.questionVisible = true
      this.isQuestionAdd = false
    },
    addIntro() {
      this.addInfo.content.push({
        type: 'text',
        text: '',
      })
    },
    delIntro(index) {
      this.addInfo.content.splice(index, 1)
    },
    chooseIntroPic(e) {
      let file = e.target.files[0]
      if (file.size > 10 * 1024 * 1024) {
        this.$message({
          message: '请上传10M以内的图片!',
          type: 'warning',
        })
        return
      }
      var _URL = window.URL || window.webkitURL
      this.addInfo.content.push({
        type: 'image',
        url: _URL.createObjectURL(file),
        file: file,
      })
    },
    chooseIntroVideo(e) {
      let file = e.target.files[0]
      if (file.size > 300 * 1024 * 1024) {
        this.$message({
          message: '请上传300M以内的视频文件!',
          type: 'warning',
        })
        return
      }
      var _URL = window.URL || window.webkitURL
      this.addInfo.content.push({
        type: 'video',
        url: _URL.createObjectURL(file),
        file: file,
      })
    },
    chooseKjVideo(e) {
      let file = e.target.files[0]
      if (file.size > 300 * 1024 * 1024) {
        this.$message({
          message: '请上传300M以内的视频文件!',
          type: 'warning',
        })
        return
      }
      var _URL = window.URL || window.webkitURL
      this.kjContentData.push({
        type: 1,
        content: {
          url: _URL.createObjectURL(file),
          file: file,
          name: file.name,
        },
      })
    },
    reChooseKjVideo(e, index) {
      console.log(e, index)
      let file = e.target.files[0]
      var _URL = window.URL || window.webkitURL
      let content = this.kjContentData[index].content
      content.url = _URL.createObjectURL(file)
      content.file = file
      content.name = file.name
      this.$set(this.kjContentData[index], 'content', content)
    },
    async onAddCourseConfirm() {
      if (!this.addInfo.course_name) {
        this.$message({
          message: '请输入课程标题！',
          type: 'warning',
        })
        return
      }
      if (!this.addInfo.grade) {
        this.$message({
          message: '请选择年级！',
          type: 'warning',
        })
        return
      }
      if (this.addInfo.vipContent === '') {
        this.$message({
          message: '请选择是否会员专享！',
          type: 'warning',
        })
        return
      }
      if (!this.addInfo.cover) {
        this.$message({
          message: '请上传封面！',
          type: 'warning',
        })
        return
      }
      // 验证介绍内容
      let hasContent = true
      this.addInfo.content.forEach((item) => {
        if (item.type == 'text' && item.text.length == 0) {
          hasContent = false
        }
      })
      if (!hasContent) {
        this.$message({
          message: '请完善课程介绍！',
          type: 'warning',
        })
        return
      }
      let params = { ...this.addInfo }
      let cover = ''
      if (this.tempPic) {
        const loading = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)',
        })
        let urlInfo = await ossPut(
          `${ossType}/admin/${Math.round(new Date())}.${
            this.tempPic.name.split('.')[1]
          }`,
          this.tempPic
        )
        loading.close()
        cover = ossOrigin + urlInfo.name
      } else {
        cover = this.addInfo.image
      }
      params.cover = cover
      // 遍历检查是否需要上传content中内容获取url
      let uploadTask = []
      let indexInAddContentArr = []
      params.content.forEach(async (item, index) => {
        if (item.type !== 'text' && item.file) {
          uploadTask.push(
            ossPut(
              `${ossType}/admin/${Math.round(new Date())}.${
                item.file.name.split('.')[1]
              }`,
              item.file
            )
          )
          indexInAddContentArr.push(index)
        }
      })
      const loading1 = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      })
      await Promise.all(uploadTask).then((res) => {
        loading1.close()
        console.log('all res', res)
        res.forEach((item, index) => {
          let url = ossOrigin + item.name
          params.content[indexInAddContentArr[index]].url = url
          delete params.content[indexInAddContentArr[index]].file
        })
      })
      // console.log('params', params)
      saveCourse(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: `${this.isAdd ? '新增' : '修改'}成功！`,
            type: 'success',
          })
          this.addVisible = false
          this.search()
        }
      })
    },
    onKsConfirm() {
      if (!this.ksName) {
        this.$message({
          message: '请输入课时标题！',
          type: 'warning',
        })
        return
      }
      let params = {
        name: this.ksName,
        course_id: this.editCourseId,
      }
      if (!this.isKsAdd) {
        params.id = this.editKsId
      }
      savePeriod(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: `${this.isKsAdd ? '新增' : '修改'}成功！`,
            type: 'success',
          })
          this.ksAddVisible = false
          this.searchKs()
        }
      })
    },
    async onKjConfirm() {
      if (!this.kjName) {
        this.$message({
          message: '请输入课件标题！',
          type: 'warning',
        })
        return
      }
      if (this.kjContentData.length == 0) {
        this.$message({
          message: '请添加课件内容！',
          type: 'warning',
        })
        return
      }
      let params = {
        title: this.kjName,
        course_period_id: this.editKsId,
        content: this.kjContentData,
      }
      if (!this.isKjAdd) {
        params.id = this.editKjId
      }
      // 遍历检查是否需要上传content中内容获取url
      let uploadTask = []
      let indexInAddContentArr = []
      params.content.forEach(async (item, index) => {
        if (item.type == 1 && item.content.file) {
          uploadTask.push(
            ossPut(
              `${ossType}/admin/${Math.round(new Date())}.${
                item.content.file.name.split('.')[1]
              }`,
              item.content.file
            )
          )
          indexInAddContentArr.push(index)
        }
      })
      const loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)',
      })
      await Promise.all(uploadTask).then((res) => {
        console.log('all res', res)
        loading.close()
        res.forEach((item, index) => {
          let url = ossOrigin + item.name
          params.content[indexInAddContentArr[index]].content.url = url
          delete params.content[indexInAddContentArr[index]].content.file
        })
      })
      saveKj(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: `${this.isAdd ? '新增' : '修改'}成功！`,
            type: 'success',
          })
          this.addKjVisible = false
          this.searchKj()
          // 新增、修改课件时，课件和课时都有变化
          this.ksChanged = true
          this.kjChanged = true
        }
      })
    },
    onQuestionConfirm() {
      if (!this.questionInfo.content.question) {
        this.$message({
          message: '请输入题干！',
          type: 'warning',
        })
        return
      }
      if (!this.questionInfo.content.answer) {
        this.$message({
          message: '请输入答案！',
          type: 'warning',
        })
        return
      }
      if (
        this.questionInfo.type == 3 &&
        !this.questionInfo.content.option1 &&
        !this.questionInfo.content.option2
      ) {
        this.$message({
          message: '请输入选项！',
          type: 'warning',
        })
        return
      }
      if (this.isQuestionAdd) {
        // 新增题目
        this.kjContentData.push(this.questionInfo)
      } else {
        // 编辑题目
        this.$set(this.kjContentData, this.editQuestionIndex, this.questionInfo)
      }
      this.questionVisible = false
    },
    toPreview(url) {
      console.log('url', url)
      // window.open(url)
      this.previewVideo = true
      this.previewVideoUrl = url
    },
    closePreview() {
      this.previewVideoUrl = ''
    },
  },
}
</script>

<style lang="less">
.courseList {
  .flex {
    display: flex;
  }
  .avatar {
    width: 100px;
    height: 60px;
    object-fit: contain;
  }
  .detail-row {
    line-height: 40px;
    margin-bottom: 20px;
  }

  .relative {
    position: relative;
  }

  .hidden-input {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }

  .img-del-button {
    position: absolute;
    top: 0;
    left: 80px;
  }

  .intro-text {
    width: 500px;
  }
  .intro-pic {
    display: block;
    width: 300px;
    height: 200px;
    margin: 0 auto;
  }
  .intro-video {
    width: 400px;
    height: 200px;
    margin-left: 50px;
  }
  .intro-del {
    position: absolute;
    top: 0;
    left: 510px;
  }
  .button-container {
    display: inline-block;
    position: relative;
    width: 100px;
    height: 40px;
    cursor: pointer;
  }
  .link {
    color: #409eff;
    cursor: pointer;
  }
  .relative {
    position: relative;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(#000, 0.5);
    z-index: 999999;
  }
  .preview-video {
    width: calc(80vw - 40px);
  }
}
</style>
